import { useState, useRef, useEffect } from 'react';
import Fuse from 'fuse.js';

export function useSearchBlogArticles({ allArticles, pageArticleSlugs }) {
  const [search, setSearch] = useState('');
  const fuseRef = useRef();

  useEffect(() => {
    fuseRef.current = new Fuse(allArticles, {
      keys: [
        'node.title',
        'node.meta_title',
        'node.meta_description',
        'node.excerpt',
        'node.tags.name',
        'node.authors.name',
      ],
    });
  }, []);

  const pageArticles = allArticles.filter(({ node }) =>
    pageArticleSlugs.includes(node.slug),
  );

  return {
    search,
    handleSearch: (event) => setSearch(event.target.value),
    articles: search
      ? fuseRef.current.search(search).map(({ item }) => item)
      : pageArticles,
  };
}
